class ProductDetails {
	constructor() {
		this.detailSections = document.querySelectorAll('.code27-detail-section');

		this.init();
	}

	init() {
		this.bindEvents();
		// 默认展开第一个详情
		this.toggleSection(this.detailSections[0]);
	}

	bindEvents() {
		this.detailSections.forEach((section) => {
			const header = section.querySelector('.code27-detail-header');
			header.addEventListener('click', () => {
				this.toggleSection(section);
			});
		});

		// 绑定按钮事件
		this.bindButtonEvents();
	}

	toggleSection(section) {
		const content = section.querySelector('.code27-detail-content');
		const isActive = section.classList.contains('active');

		// 先设置具体高度，以便动画
		if (!isActive) {
			// 关闭其他展开的部分
			this.detailSections.forEach((s) => {
				if (s !== section && s.classList.contains('active')) {
					const otherContent = s.querySelector('.code27-detail-content');
					otherContent.style.height = `${otherContent.scrollHeight}px`;
					requestAnimationFrame(() => {
						otherContent.style.height = '0';
						s.classList.remove('active');
					});
				}
			});

			// 展开当前部分
			content.style.height = '0';
			section.classList.add('active');
			requestAnimationFrame(() => {
				content.style.height = `${content.scrollHeight}px`;
			});
		} else {
			// 收起当前部分
			content.style.height = `${content.scrollHeight}px`;
			requestAnimationFrame(() => {
				content.style.height = '0';
				section.classList.remove('active');
			});
		}
	}

	bindButtonEvents() {
		const pledgeBtn = document.querySelector('.code27-btn-outline');
		const buyBtn = document.querySelector('.code27-btn-primary');

		pledgeBtn?.addEventListener('click', () => {
			this.handlePledge();
		});

		buyBtn?.addEventListener('click', () => {
			this.handleBuyNow();
		});
	}

	handlePledge() {
		// 添加加载状态
		const btn = document.querySelector('.code27-btn-outline');
		const originalText = btn.textContent;
		btn.textContent = 'Redirecting...';
		btn.style.opacity = '0.7';

		setTimeout(() => {
			btn.textContent = originalText;
			btn.style.opacity = '1';
			alert('Redirecting to Kickstarter...');
		}, 1500);
	}

	handleBuyNow() {
		// 添加购买动画
		const btn = document.querySelector('.code27-btn-primary');
		const originalText = btn.textContent;

		btn.textContent = 'Processing...';
		btn.style.background = 'linear-gradient(135deg, #00C851, #00FF7F)';

		setTimeout(() => {
			btn.textContent = '✓ Added to Cart';
			setTimeout(() => {
				btn.textContent = originalText;
				btn.style.background = 'linear-gradient(135deg, #8B5CF6, #3B82F6)';
			}, 2000);
		}, 1000);
	}
}

new ProductDetails();
